"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IssueProviderContext = exports.IssueProvider = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _accLocationsComponents = require("@adsk/acc-locations-components");
var _store = require("./state/redux/store");
var _reduxContext = require("./state/redux/reduxContext");
var _sdkContext = require("./state/sdk/sdkContext");
var _globals = require("./utils/styles/globals");
var _featureFlags = require("./utils/featureFlags");
var _IssuePlacementContext = require("./IssuePlacementContext");
var _context = require("./input-field-components/ReferencePickerField/context");
var _reactQuery = require("@tanstack/react-query");
var _useIssuesQueryClient = require("./state/sdk/useIssuesQueryClient");
var _CustomEventContext = require("./CustomEventContext");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const IssueProviderContext = exports.IssueProviderContext = _react.default.createContext(false);
const IssueProviderInternal = _ref => {
  let {
    projectId,
    children,
    getIssuePlacementUrl,
    referencePickerPlugins = null,
    onCustomEvent
  } = _ref;
  const {
    value: useReactQuery
  } = (0, _featureFlags.useFeatureFlag)(_featureFlags.FeatureFlag.UseReactQuery);
  const queryClient = (0, _useIssuesQueryClient.useIssuesQueryClient)();

  /**
   * We only create the store object but don't start the initialization process
   * until the feature flags are fully loaded. So we can include the cosv3 header
   * on every request that we send to the issues backend.
   * */
  const {
    sdk,
    store
  } = (0, _store.getOrInitializeStore)({
    projectId,
    shouldInitializeStore: false
  });

  /**
   * When the feature flags are stopped loading we update the sdk configuration
   * with the correct headers and kick off the initialization process.
   * */
  const storeInitializedAt = (0, _store.getStoreInitializationTime)();
  const canInitializeStore = storeInitializedAt === undefined;
  if (canInitializeStore) {
    (0, _store.updateSingletonSdkConfig)({
      projectId,
      useReactQuery
    });
    (0, _store.initializeIssuesReduxStore)();
  }
  return /*#__PURE__*/_react.default.createElement(_reactQuery.QueryClientProvider, {
    client: queryClient
  }, /*#__PURE__*/_react.default.createElement(_sdkContext.sdkContext.Provider, {
    value: sdk
  }, /*#__PURE__*/_react.default.createElement(_IssuePlacementContext.IssuePlacementContext.Provider, {
    value: getIssuePlacementUrl
  }, /*#__PURE__*/_react.default.createElement(_CustomEventContext.CustomEventContext.Provider, {
    value: onCustomEvent
  }, /*#__PURE__*/_react.default.createElement(_accLocationsComponents.LocationProvider, {
    projectId: projectId
  }, /*#__PURE__*/_react.default.createElement(_context.ReferencePluginsContext.Provider, {
    value: referencePickerPlugins
  }, store ? /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
    store: store,
    context: _reduxContext.reduxContext
  }, children) : children)), /*#__PURE__*/_react.default.createElement(_globals.GlobalStyles, null)))));
};
const IssueProvider = props => {
  return /*#__PURE__*/_react.default.createElement(IssueProviderContext.Provider, {
    value: true
  }, /*#__PURE__*/_react.default.createElement(_featureFlags.IssuesLaunchDarklyProvider, null, /*#__PURE__*/_react.default.createElement(IssueProviderInternal, props)));
};
exports.IssueProvider = IssueProvider;
IssueProvider.displayName = "IssueProvider";
//# sourceMappingURL=IssueProvider.js.map